<template>
  <v-app class="bg-background">

    <AppBar :show=showPages></AppBar>
    <NavigationDrawer v-if="showNavigationDrawer" :show="showPages"></NavigationDrawer>

    <v-main transition="slide-x-transition" style="--v-layout-top: 28px;">
      <!-- Provides the application the proper gutter -->
      <v-container fluid class="pa-0 page-color" v-resize="onResize">
        <v-overlay persistent :model-value="loading" class="align-center justify-center">
          <v-progress-circular :size="100" :width="7" color="domain-button-color" indeterminate></v-progress-circular>
        </v-overlay>

        <router-view v-if="showPages" v-slot="{ Component }">
          <component :is="Component" />
        </router-view>



      </v-container>
    </v-main>

    <v-snackbar class="snackbar-class" color="error" origin="right" location="top right" position="fixed" timeout="2200"
      rounded v-model="showErrorSnackbar" vertical>
      Network error
    </v-snackbar>
    <v-dialog v-model="logoutUserSession" max-width="400">
      <v-card>
        <v-card-title>
          <v-icon color="red" size="x-large" class="mr-2">mdi-alert-circle</v-icon>
          Multiple Sessions Detected
        </v-card-title>
        <v-card-text>
          You have been logged out from this session because multiple sessions were detected. Please log in again if you
          wish to continue.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="confirmLogout">logout</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { useDisplay } from 'vuetify';
import { initializeAWSPinpointAnalytics } from "@/services/awsPinpointAnalyticsService";
import NavigationDrawer from "@/components/appNavigation/NavigationDrawer.vue";
import AppBar from "@/components/appNavigation/AppBar.vue";
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";
import { checkLogsSizeInKB } from "./services/logService";

export default {
  name: "App",
  setup() {
    const { mdAndUp } = useDisplay();

    return { mdAndUp }
  },

  data: () => ({
    showPages: false,
    showNavigationDrawer: false
  }),
  components:
  {
    NavigationDrawer,
    AppBar
  },
  async created() {
    this.$store.commit("updateUserLoggedIn");
    await this.$store.dispatch("getAPIUrlsForFlavorAndVersion");
    this.showNavigationDrawer = true
    if (this.$route.name === "sso") {
      this.$store.commit("isSSOLogin", true);
    }
    initializeAWSPinpointAnalytics();
    this.showPages = true;
    if (!this.mdAndUp) {
      this.$store.commit('updateNavDrawer', false);
    }
    recordAnalyticsEvent(AnalyticsEvents.v2AppLoaded);
    this.$store.dispatch('fetchProfileInfo');
    this.$store.dispatch('checkFeatures');
    
    // Load notifications from DB and update unread count
    await this.$store.dispatch('loadUserMessages');
    this.$store.dispatch('fetchUnreadNotificationsCount');
    
    await this.checkLogsAndSendToServer();
  },
  mounted() {
  this.unreadInterval = setInterval(async () => {
    await this.$store.dispatch('loadUserMessages');
    this.$store.dispatch('fetchUnreadNotificationsCount');
  }, 60000); 
},
  beforeUnmount() {
    clearInterval(this.unreadInterval);
  },
  computed: {
    ...mapState(["loading", "navDrawer", "errorLogs", "networkErrorLogs", "testErrorLogs", "logoutUserSession"]),
    showErrorSnackbar: {
      get() {
        return this.$store.state.errorSnackbar;
      },
      set(val) {
        //console.log("snackbar val", val)
        this.$store.commit("setErrorSnackbar", val);
      }
    },
  },

  watch: {
    // loading(newVal, oldVal) {
    //   console.log(`watching 'loading' || changed from ${oldVal} to ${newVal}`);
    // }
  },

  methods: {
    confirmLogout() {
      recordAnalyticsEvent(AnalyticsEvents.v2SignoutUserSession);
      //console.log("confirmed user logout");
      this.$store.dispatch("logout").then(() => {
        this.$router.push('/');
        this.$store.commit("updateUserLoggedIn");
        this.$store.commit("clearLogoutSessionVal");
      });
    },
    closeErrorSnackbar() {
      this.$store.commit("setErrorSnackbar", false);
    },
    initialize() { },
    onResize() {
      //console.log(`window resized...:: ${window.innerWidth} || ${window.innerHeight}`);
      if (!this.mdAndUp) {
        this.hideDrawer();
      } else {
        this.showDrawer();
      }
    },
    showDrawer() {
      this.$store.commit("toggleDrawer", true);
    },
    hideDrawer() {
      this.$store.commit("toggleDrawer", false);
    },
    async checkLogsAndSendToServer() {
      console.log(checkLogsSizeInKB(this.errorLogs), checkLogsSizeInKB(this.networkErrorLogs), checkLogsSizeInKB(this.testErrorLogs))
      if (checkLogsSizeInKB(this.errorLogs) > 200) {
        console.log("ui-errorLogsSize", checkLogsSizeInKB(this.errorLogs));
        this.$store.dispatch("sendLogsToServer", { logsName: "ui-errorLogs" });
      }
      if (checkLogsSizeInKB(this.networkErrorLogs) > 200) {
        console.log("network-errorLogsSize", checkLogsSizeInKB(this.networkErrorLogs));
        this.$store.dispatch("sendLogsToServer", { logsName: "network-errorLogs" });
      }
      if (checkLogsSizeInKB(this.testErrorLogs) > 200) {
        console.log("test-errorLogsSize", checkLogsSizeInKB(this.testErrorLogs));
        this.$store.dispatch("sendLogsToServer", { logsName: "test-errorLogs" });
      }
    },
    fetchUnreadCount() {
      this.$store.dispatch("fetchUnreadNotificationsCount");
    },
  }
};
</script>

<style>
html {
  overflow: hidden !important;
}

@import url('https://fonts.googleapis.com/css2?family=Inter');

html,
body {
  font-family: 'Inter', sans-serif !important;

}

html {
  overflow-y: scroll !important;

}

#app {
  font-family: 'Inter', sans-serif !important;
}

.btn-rd {
  border-radius: 8px !important;
}

.htmlClass {
  color: black !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 0.875rem !important
}

.htmlClassTest {
  color: black !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 1rem !important
}

.t-h6 {
  font-family: 'Inter', sans-serif !important;
  color: black !important;
  font-size: 0.875rem !important;
  font-style: normal !important;
  font-weight: 600 !important;

}

.t-h5 {
  font-family: 'Inter', sans-serif !important;
  font-size: 1.125rem !important;
  font-style: normal !important;
  font-weight: 600 !important;
  color: black !important;

}

.t-h5Reg {
  font-family: 'Inter', sans-serif !important;
  font-size: 1.125rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: black !important;

}

.t-h4 {
  font-family: 'Inter', sans-serif !important;
  font-size: 1.4rem !important;
  font-style: normal !important;
  font-weight: 600 !important;
  color: black !important;

}

.t-h4Reg {
  font-family: 'Inter', sans-serif !important;
  font-size: 1.4rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: black !important;

}

.t-subtitle {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.8rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: #323232 !important;
}

.t-para {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.8rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: black !important;
}

.t-btn {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.875rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
}

.t-h6Reg {
  font-family: 'Inter', sans-serif !important;
  color: black !important;
  font-size: 0.875rem !important;
  font-style: normal !important;
  font-weight: 500 !important;
}

.v-alert-title {
  font-family: 'Inter', sans-serif !important;
  font-size: 1.125rem !important;
  font-style: normal !important;



}

.v-alert__content {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.875rem !important;
  font-style: normal !important;


}

.v-toolbar-title {
  font-family: 'Inter', sans-serif !important;
  font-style: normal !important;
  font-size: 1.1rem !important;
}

.dialog-bx {
  font-family: 'Inter', sans-serif !important;
  font-style: normal !important;

}

.v-avatar {
  font-family: 'Inter', sans-serif !important;
  font-style: normal !important;
}

.snackbar-class {
  top: 80px !important;
}

.grey-bx {
  /* box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important; */
}
</style>
